<template>
  <div class="newsletter" @click="setSlideSignUp(true)">
    <div class="content">
      <h2 v-if="mq.mdPlus" class="newsletter__title">
        Sign up to Members Only.
      </h2>
      <h2 v-else class="newsletter__title">
        Sign up to Members Only for exclusive access and bespoke benefits
      </h2>

      <div class="newsletter__link">Signup Now</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Newsletter",
  inject: ["mq"],
  methods: {
    ...mapActions("app", ["setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.newsletter {
  background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/newslettter_1.jpg?v=1652705368");
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  margin: 60px 0 0 0;
  position: relative;
  width: 100%;

  &::after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  @include respond-above(md) {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/newsletter-desktop_02e314e1-132d-42fc-8f5e-0a10d25bc435.jpg");
    background-position: top center;
    height: 650px;
    margin: 80px 0 0 0;

    &::after {
      content: "";
      display: block;
      padding-bottom: 0;
    }
  }

  .content {
    padding: 20px;
    position: absolute;
    width: 100%;
    height: 100%;

    @include respond-above(md) {
      display: flex;
      justify-content: center;
      align-items: baseline;
      flex-flow: column;
    }
  }
}

.newsletter__title {
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: $color-white;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;

  @include respond-above(md) {
    font-size: 50px;
    max-width: 500px;
  }
}

.newsletter__link {
  font-size: 9px;
  font-weight: 600;
  color: $color-white;
  text-transform: uppercase;
  text-decoration: none;

  @include respond-above(md) {
    font-size: 10px;
  }
}
</style>
